export function updateArray<T>(
  rows: ReadonlyArray<T>,
  predicate: (x: Readonly<T>) => boolean,
  patch: (previous: Readonly<T>) => Readonly<T>,
): ReadonlyArray<T> {
  const rowIndex = rows.findIndex(predicate);
  if (rowIndex === -1) {
    return rows;
  }
  const previous = rows[rowIndex];
  const copy = [...rows];
  copy[rowIndex] = patch(previous);
  return copy;
}
